/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Card,
  Divider,
  HStack,
  Heading,
  Scrollable,
  Stack,
  Text,
  Wrap,
  WrapItem,
  Tooltip,
  IconButton,
  Box,
  VStack
} from '@mybridge/ui';
import { MyProfileActivity } from 'v4/components/public-profile/activity';
import {
  ChatIcon,
  Eye,
  EyeViewIcon,
  FollowIcon,
  FollowingIcon,
  HandShakeSimpleIcon,
} from '@mybridge/icons';
import { MyProfileIntroduction } from 'v4/components/public-profile/introduction';
import { MyProfilePersonalInfo } from 'v4/components/public-profile/personal-info';
import { MyProfileInterests } from 'v4/components/public-profile/interests';
import { MyProfileCauses } from 'v4/components/public-profile/causes';
import { MyProfileDegreeConnections } from 'v4/components/public-profile/degree-connections';
import { useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import { ManageTestimonialIcon } from '@mybridge/icons';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyProfileNetworkSuggestionsList } from 'v4/components/public-profile/suggestions-list';
import Link from 'next/link';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { MyNetworkCircleCardMenu } from '../../network/circle-menu';
import { isMobile } from 'react-device-detect';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
export const MyPublicProfilePosts = () => {
  const {
    connections,
    publicProfile,
    userProfileInfo,
    hasPersonalInfo,
    hasIntro,
    loggedIn,
    refetchConnections,
    mutualConnections,
    refetchMutualConnections,
    hasWebsite,
    hasInterestedIn,
    hasCauses,
    hasLinks,
  } = useContext(PublicProfileContext);
  const {
    handshakeUser,
    handshakeLoading,
    isHandshaked,
    followUser,
    followLoading,
    unfollowUser,
    unfollowLoading,
    isFollowed,
    isHandshakedRequested,
    isFriend,
    allSuggestions,
    refetchSuggestions,
    unfriendLoading,
    selectedUser,
    setSelectedUser,
    setHandshakeSelectedUser,
    handshakeMessageDisc,
    handleHandshakeSendRevoke,
    revokeHandshakeLoading,
    filters = {},
  } = useContext(MyNetworkContext);
  const { startChatSingle } = useContext(MatrixContext);
  const { profile_intro: intro, profile_headline: headline } =
    userProfileInfo ?? {};

  useEffect(() => {
    loggedIn && refetchConnections?.();
    loggedIn && refetchMutualConnections?.();
  }, []);

  const handleProfileHandshake = (user) => {
    setHandshakeSelectedUser(user);
    handshakeMessageDisc?.onOpen();
  };


  return (
    <>
      <Stack direction={['column', 'row']} spacing={4} alignItems="flex-start">
        {/* {!isMobile ? (
          <></>
        ) : (
          <>
            {/* <Stack p={2}> */}
            {/* <Stack px={4} py={0} spacing={4} w="100%">
              {hasIntro && (
                <Card variant="thinBorderedCard">
                  <MyProfileIntroduction />
                </Card>
              )}
              {/* {hasWebsite || hasInterestedIn || hasCauses || hasLinks ? (
                <Card p={3} variant="thinBorderedCard">
                  <MyProfilePersonalInfo displayCard={true} />
                </Card>
              ) : (
                ''
              )} */}
              {/* {isFriend?.(publicProfile) && (
                <Card p={3} variant="thinBorderedCard">
                  <Text mb={3} fontSize="14px" color="#868585">
                    Give or Ask {publicProfile?.display_name} for testimonial
                  </Text>
                  <Link href="/profile/testimonials">
                    <Button
                      leftIcon={<ManageTestimonialIcon />}
                      variant="secondary"
                      color="#868585"
                      size="lg"
                      maxW="fit-content"
                    >
                      Manage testimonial
                    </Button>
                  </Link>
                </Card>
              )} */}

              {/* {!isFriend?.(publicProfile) && (
                <ForceSignInWrapper>
                <Card p={3} variant="thinBorderedCard">
                  <Text mb={3} fontSize="14px" color="#868585">
                    Send {publicProfile?.display_name} handshake request
                  </Text>

                  {isHandshaked?.(publicProfile) ? (
                    <Button
                      variant="secondary"
                      color="#868585"
                      maxW="fit-content"
                      leftIcon={
                        <HandShakeSimpleIcon
                          width="20"
                          height="20"
                          color="rgb(179, 140, 140)"
                        />
                      }
                      isLoading={revokeHandshakeLoading}
                      // onClick={() => handshakeUser(publicProfile)}
                      onClick={() => handleHandshakeSendRevoke(publicProfile)}
                    >
                      Withdraw Handshake
                    </Button>
                  ) : (
                    <Button
                      variant="secondary"
                      color="#868585"
                      maxW="fit-content"
                      leftIcon={
                        <HandShakeSimpleIcon
                          width="20"
                          height="20"
                          color="rgb(148, 176, 150)"
                        />
                      }
                      isLoading={
                        (unfriendLoading || handshakeLoading) &&
                        selectedUser?.id === publicProfile?.id
                      }
                      // onClick={() => handshakeUser(publicProfile)}
                      onClick={() => handleProfileHandshake(publicProfile)}
                    >
                      Handshake
                    </Button>
                  )}
                </Card>
                </ForceSignInWrapper>
              )} */}

              {/* {loggedIn && connections?.pages?.[0]?.count > 0 ? (
                <Box variant="thinBorderedCard" mt={3}>
                  <Heading
                    fontSize="20px"
                    color="brandPrimary.500"
                    fontWeight="600"
                  >
                    {publicProfile?.display_name}&apos; Connections
                  </Heading>
                  <HStack justifyContent="space-between" mb={3}>
                    <Text fontSize="sm">
                      {connections?.pages?.[0]?.count}{' '}
                      <>
                        {!mutualConnections?.count && (
                          <Box as="span">Connections</Box>
                        )}
                      </>
                      <>
                        {mutualConnections?.count > 0 && (
                          <>({mutualConnections?.count} shared connections)</>
                        )}
                      </>
                    </Text>

                    <Link href="#">See all</Link>
                  </HStack>

                  <Wrap spacing={4} m={1}>
                    {connections?.pages?.[0]?.results
                      ?.slice(0, 4)
                      ?.map((cu, i) => (
                        <WrapItem
                          key={i}
                          minW="160px"
                          maxW={['49%', '30%', '250px']}
                          flexGrow={['1', '1', 0]}
                          flexShrink={['1', '1', 0]}
                        >
                          <MyNetworkUserCardBordered
                            user={cu}
                            actions={
                              userProfileInfo?.id !== cu?.id ? (
                                isFriend(cu) ? (
                                  <HStack justifyContent="center">
                                    <IconButton
                                      onClick={(e) => startChatSingle(cu)}
                                    >
                                      <ChatIcon width={20} height={20} />
                                    </IconButton>

                                    <MyNetworkCircleCardMenu user={cu} />
                                  </HStack>
                                ) : (
                                  <HStack justifyContent="center">
                                    <Tooltip
                                      label={
                                        isHandshaked(cu)
                                          ? 'Handshake sent'
                                          : 'Handshake'
                                      }
                                    >
                                      <IconButton
                                        onClick={(e) => {
                                          if (isHandshaked(cu)) return;
                                          setSelectedUser(cu);
                                          handshakeUser(cu);
                                        }}
                                        variant="secondary"
                                        isLoading={
                                          (unfriendLoading ||
                                            handshakeLoading) &&
                                          selectedUser?.id === cu?.id
                                        }
                                        isDisabled={isHandshaked(cu)}
                                      >
                                        <HandShakeSimpleIcon
                                          color={'rgb(148, 176, 150)'}
                                          width={20}
                                          height={20}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </HStack>
                                )
                              ) : (
                                <HStack justifyContent="center">
                                  <Link href="/profile/me">
                                    <IconButton>
                                      <Eye
                                        color="#9F9F9F"
                                        width="22"
                                        height="15"
                                      />
                                    </IconButton>
                                  </Link>
                                </HStack>
                              )
                            }
                          />
                        </WrapItem>
                      ))}
                  </Wrap>
                </Box>
              ) : (
                ''
              )}
            </Stack>
          </>
        )} */}

        {/* {isMobile && (
           <VStack align="stretch" maxW={["100%","70%"]} gap={10} p={3} borderLeft="1px solid #ddd">
            <Card p={4} width="90vw" boxShadow="none">
              <MyProfilePersonalInfo />
            </Card>
            {/* <Card p={4} variant="lightBgCard">
              <MyProfileInterests />
            </Card>
            <Card p={4} variant="lightBgCard">
              <MyProfileCauses />
            </Card>
            <Card p={4} variant="lightBgCard">
              <MyProfileAnalytics />
            </Card> */}
          {/* </VStack>
        )} */}
        {/* {isMobile && (
          <Box px={4} w="100%">
            <MyProfilePersonalInfo />
          </Box>
        )} */}
        <Stack w={['100%', '100%', '100%']} spacing={6} px={[4, 0]} py={[2, 0]}>
          <MyProfileActivity />
        </Stack>
      </Stack>
    </>
  );
};
